import { postApi } from "../apis";

export const loginUser = (data) => {
    return postApi('/api/auth/login', data);
};

export const registerUser = (data) => {
    return postApi('/api/auth/register', data);
};